import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <div>Movie App</div>
      <div>©2021, Movie, Inc. or its affiliates</div>
    </div>
  );
};

export default Footer;
